module.exports = __webpack_public_path__ + "static/media/profile-pic-4.4b8f3d51.jpg";